import { StyleSheet } from 'react-native';

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  scrollViewStyle: {
    maxHeight: 250,
  },
  scrollViewBorder: theme => ({
    borderTopWidth: 1,
    borderTopColor: theme.colors.divider,
    borderBottomWidth: 1,
    borderBottomColor: theme.colors.divider,
  }),
  button: {
    marginBottom: 32,
    marginHorizontal: 17,
  },
  editAccountTextStyle: theme => ({
    color: theme.colors.textColorTwo,
    textDecorationLine: 'underline',
    marginVertical: 16,
  }),
  editAccount: {
    alignSelf: 'center',
  },
  title: theme => ({
    fontFamily: Fonts.type.VodafoneLt,
    fontSize: 25,
    lineHeight: 31.2,
    color: theme.colors.headerTitleColor,
    marginBottom: 32,
    marginTop: 8,
    paddingHorizontal: 17,
  }),
  accountNameText: {
    fontSize: 18.7,
  },
  itemContainerStyle: {
    marginHorizontal: 17,
  },
});
